import { render, staticRenderFns } from "./ModalLoginHistory.vue?vue&type=template&id=0a907b81&scoped=true&lang=pug&"
import script from "./ModalLoginHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalLoginHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLoginHistory.vue?vue&type=style&index=0&id=0a907b81&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a907b81",
  null
  
)

export default component.exports